import { Switch, Route, useRouteMatch } from 'react-router-dom';

import DotMailerContacts from '@pages/contacts/dotmailerContacts/DotMailerContacts';
import DotMailerContactSingle from '@pages/contacts/dotmailerContacts/DotMailerContactSingle';

const DotMailerContactsRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}>
                <DotMailerContacts />
            </Route>
            <Route exact path={`${path}/:id`}>
                <DotMailerContactSingle />
            </Route>
        </Switch>
    );
};

export default DotMailerContactsRoutes;
